import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/** @param {{ query?: { tagGroupId?: string, employeeId?: string, parasutAccountId?: string, page?: number, limit?: number } }} option */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.TagTimeline.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};
export default { GetAll };
